import { render } from "./validation-errors.vue?vue&type=template&id=102b52e8&scoped=true"
import script from "./validation-errors.vue?vue&type=script&lang=js"
export * from "./validation-errors.vue?vue&type=script&lang=js"

import "./validation-errors.vue?vue&type=style&index=0&id=102b52e8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-102b52e8"]])

export default __exports__